/**
 * VendorProductLogService
 * Service for managing vendor product logs
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product log CRUD operations with product-specific queries
 */
export class VendorProductLogService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductLogService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductLogService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all logs for a specific product
     * @param productId - Product ID
     * @returns Array of vendor product log views
     */
    async getByProduct(productId) {
        const response = await this.getByProductRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get all logs for a specific product with full response
     * @param productId - Product ID
     * @returns ResponseData with array of vendor product log views
     */
    getByProductRaw(productId) {
        const url = this.buildUrl(`product/${productId}`);
        return this.http.get(url);
    }
}
VendorProductLogService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductLogService.BASE_PATH = 'api/vendor-product-logs';
//# sourceMappingURL=VendorProductLogService.js.map